import "@/App.css";
import { useState, useEffect, useRef } from "react";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import EventDetails from "./components/EventDetails";
import CountdownTimer from "./components/CountdownTimer";
import Gallery from "./components/Gallery";
import StorySection from "./components/StorySection";
import RsvpSection from "./components/RsvpSection";
import GiftSection from "./components/GiftSection";
import Footer from "./components/Footer";
import EnvelopeOpening from "./components/EnvelopeOpening";
import { Volume2, VolumeX } from "lucide-react";

function App() {
  const [isEnvelopeOpen, setIsEnvelopeOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const audioRef = useRef(null);

  const startMusic = () => {
    if (!audioRef.current) {
      const audio = new Audio("/musica.mp3");
      audio.loop = true;
      audio.volume = 0.5;
      audio.preload = "auto";
      audioRef.current = audio;
    }
    audioRef.current.play().catch(() => {
      const retry = () => {
        if (audioRef.current && audioRef.current.paused) {
          audioRef.current.play().catch(() => {});
        }
        document.removeEventListener("pointerdown", retry);
        document.removeEventListener("touchend", retry);
      };
      document.addEventListener("pointerdown", retry);
      document.addEventListener("touchend", retry);
    });
  };

  useEffect(() => {
    if (isEnvelopeOpen) {
      startMusic();
    }
  }, [isEnvelopeOpen]);

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
    }
    setIsMuted(!isMuted);
  };

  return (
    <div className="App min-h-screen bg-background">
      {!isEnvelopeOpen && (
        <EnvelopeOpening onOpen={() => setIsEnvelopeOpen(true)} onStartMusic={startMusic} />
      )}
      
      <div className={`transition-opacity duration-1000 ${isEnvelopeOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <Navigation />
        <main>
          <HeroSection />
          <StorySection />
          <EventDetails />
          <CountdownTimer />
          <Gallery />
          <GiftSection />
          <RsvpSection />
        </main>
        <Footer />
      </div>

      {isEnvelopeOpen && (
        <button
          onClick={toggleMute}
          aria-label={isMuted ? "Attiva musica" : "Disattiva musica"}
          className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full border border-gold/40 bg-card/90 backdrop-blur-sm shadow-soft flex items-center justify-center text-lavender hover:bg-lavender hover:text-white transition-colors duration-300"
          data-testid="music-toggle-button"
        >
          {isMuted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
        </button>
      )}
    </div>
  );
}

export default App;
